import React from 'react';
import classNames from 'classnames/bind';
import { Widget } from '@creditsights/styleguide-web';
import { RecommendationDto } from '../../../../services/dtos/issuer/recommendation.dto';
import WeightIcon from '../../../WeightIcon';
import CSViewWidgetContent from '../CSViewWidgetContent';
import styles from '../CSViewCompanyWidget/CSViewCompanyWidget.module.scss';

const cx = classNames.bind(styles);

interface CSViewCompanyPrintWidgetProps {
  issuerTag: string;
  companyRecommendation: RecommendationDto | undefined;
}

const CSViewCompanyPrintWidget = ({
  issuerTag,
  companyRecommendation,
}: CSViewCompanyPrintWidgetProps): React.ReactElement | null => {
  if (!companyRecommendation) {
    return null;
  }

  const header = <div className={cx('heading')}>CS View</div>;

  return (
    <Widget headerTitle={header} dataTestId="cs-view-company-print">
      <div className={cx('print-body')}>
        {companyRecommendation.weighting && (
          <div className={cx('print-icon')}>
            <WeightIcon weighting={companyRecommendation.weighting} />
          </div>
        )}
        <CSViewWidgetContent
          print
          data={companyRecommendation}
          issuerTag={issuerTag}
          showLinkToCompany={false}
          truncateContent={false}
        />
      </div>
    </Widget>
  );
};

export default CSViewCompanyPrintWidget;
